export const UPDATE_DELETE_POPUP = "UPDATE_DELETE_POPUP";
export const FETCH_DRAFT_WARRANTY_LIST_SUCCESS = "FETCH_DRAFT_WARRANTY_LIST_SUCCESS";
export const DELETE_DRAFT_WARRANTY_ITEM_SUCCESS = "DELETE_DRAFT_WARRANTY_ITEM_SUCCESS";
export const DELETE_DRAFT_WARRANTY_ITEM = "DELETE_DRAFT_WARRANTY_ITEM";
export const FETCH_DRAFT_WARRANTY_LIST = "FETCH_DRAFT_WARRANTY_LIST";
export const ADD_DASHBOARD_CLICK_ELEMENTS = "ADD_DASHBOARD_CLICK_ELEMENTS";